import React from 'react';
import { BilateralHomepage } from './components/BilateralHomepage';

export default function App() {
  return <BilateralHomepage />;
}
